import { getUrlShippingRequestApi } from '../utils/util';
import { ShippingRequestSearch, ShippingRequestPost, 
    ShippingRequestPut, ShippingRequestSupplierSearch, 
    ShippingRequestSupplierPost, ShippingRequestMonitorSearch,
    ShippingRequestInvoiceValidatePut } from '../interfaces/ShippingRequest'
import getUrlParameters from '../utils/getUrlParameters';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlShippingRequestApi(window));

export default class ShippingRequestApi {

    static async create(params: ShippingRequestPost) {
        var response = await ApiHandler(baseURL).post('ShippingRequest', params);
        return response.data;
    }

    static async delete(id: number) {
        var response = await ApiHandler(baseURL).delete('ShippingRequest/' + id);
        return response.data;
    }

    static async search(params: ShippingRequestSearch) {
        var response = await ApiHandler(baseURL).get('ShippingRequest/search', { params: getUrlParameters(params) });
        return response.data;
    }

    static async get(id: number) {
        var response = await ApiHandler(baseURL).get(`ShippingRequest/${id}`);
        return response.data;
    }

    static async post(post: ShippingRequestPost) {
        var response = await ApiHandler(baseURL).post('ShippingRequest', post);
        return response.data;
    }

    static async put(put: ShippingRequestPut) {
        var response = await ApiHandler(baseURL).put('ShippingRequest', put);
        return response.data;
    }

    // static async approve(put: ShippingRequestInvoiceValidatePut) {
    //     var response = await ApiHandler(baseURL).put('ShippingRequest/approve-invoice', put);
    //     return response.data;
    // }

    static async disapprove(put: ShippingRequestInvoiceValidatePut) {
        var response = await ApiHandler(baseURL).put('ShippingRequest/disapprove-invoice', put);
        return response.data;
    }

    static async cancellation(id: number, user: string) {
        var response = await ApiHandler(baseURL).put(`ShippingRequest/cancel/${id}`);
        return response.data;
    }

    static async deleteCode(code: string, plantId: number) {
        var response = await ApiHandler(baseURL).delete(`ShippingRequest/?code=${code}&plantId=${plantId}`);
        return response.data;
    }

    static async approve(put: ShippingRequestInvoiceValidatePut) {
        var response = await ApiHandler(baseURL).put('ShippingRequest/approve-validation', put);
        return response.data;
    }

    static async reject(put: ShippingRequestPut) {
        var response = await ApiHandler(baseURL).put('ShippingRequest/reject-validation', put);
        return response.data;
    }

    static async getStartsWith(text: any) {
        var response = await ApiHandler(baseURL).get(`ShippingRequest/startsWith?beginsWith=${text.code}`);
        return response.data;
    }

    static async searchSupplier(params: ShippingRequestSupplierSearch) {
        var response = await ApiHandler(baseURL).get('ShippingRequest/search-suppliers', { params: getUrlParameters(params) });
        return response.data;
    }

    static async postSupplier(post: ShippingRequestSupplierPost) {
        var response = await ApiHandler(baseURL).post('ShippingRequest/supplier', post);
        return response.data;
    }

    static async deleteSupplier(supplierId: number, companyId: number) {
        var response = await ApiHandler(baseURL).delete(`ShippingRequest/supplier/?supplierId=${supplierId}&companyId=${companyId}`);
        return response.data;
    }

    static async searchMonitor(params: ShippingRequestMonitorSearch) {
        var response = await ApiHandler(baseURL).get('ShippingRequest/search-monitor', { params: getUrlParameters(params) });
        return response.data;
    }

    static async searchSchedule(shippingRequestId: number, companyId: number, supplierId: number, supplierSapCode: string) {
        var response = await ApiHandler(baseURL).get(`ShippingRequest/searchScheduledPartNumbers?shippingRequestId=${shippingRequestId}&companyId=${companyId}&supplierId=${supplierId}&supplierSapCode=${supplierSapCode}`);
        return response.data;
    }

    static async cancel(id: number) {
        var response = await ApiHandler(baseURL).put('ShippingRequest/cancel?id=' + id);
        return response.data;
    }

    static async getMultiple(ids: string) {
        var response = await ApiHandler(baseURL).get('ShippingRequest/get-multiple?ids=' + ids);
        return response.data;
    }
}
